<template>
    <div class="or-page-title flex-row flex-center">
        <h2 class="title"><slot></slot></h2>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .or-page-title {
        background-image: url(../../assets/page-title-bg.jpg);
        background-position: center;
        background-size: cover;
        width: 100%;
        height: 220px;
    }
    .title {
        font-size: 60px;
        line-height: 70px;
        text-align: center;
        color: #FFFFFF;
    }
</style>